import { FC, useMemo } from 'react'
import cn from 'classnames'

import RiskBadge from '../../badge/risk-badge'
import DropdownButton from '../../dropdown-button/dropdown-button'
import { IListItemProps } from '../../list'

import { ISafetyCaseHazard } from '../../../interfaces'

import s from '../card.module.scss'

type SafetyCaseHazardCardProps = ISafetyCaseHazard & IListItemProps<ISafetyCaseHazard>

const SafetyCaseHazardCard: FC<SafetyCaseHazardCardProps> = props => {
  const { id, name, description, selectedRiskMatrixCell, componentRef, activeId, onTitleClick, actionsButtonOptions } =
    props

  const title = useMemo(() => `#${id} ${name ? ` - ${name}` : ''}`, [id, name])

  return (
    <div
      className={cn('card card-custom border border-2 p-4 d-flex flex-column', activeId === id && s['active-card'])}
      ref={componentRef}
    >
      <div className={cn(s['card-header'], 'card-header border-0 m-0 p-0')}>
        <div
          className={cn('card-title font-weight-bold flex-grow-1 mr-2', onTitleClick && 'cursor-pointer')}
          style={{ minWidth: 0 }}
          // @ts-ignore
          onClick={() => onTitleClick(props)}
        >
          <span className="d-block text-truncate">{title}</span>
        </div>

        {actionsButtonOptions && (
          <DropdownButton className={s['actions-button']} accessor={props} options={actionsButtonOptions} />
        )}
      </div>

      <div className="card-body p-0">{description && <div className="mt-2 text-truncate">{description}</div>}</div>

      {selectedRiskMatrixCell && (
        <div className="border-0 card-footer d-flex justify-content-end mt-auto mx-0 p-0 pt-2">
          <RiskBadge risk={selectedRiskMatrixCell} />
        </div>
      )}
    </div>
  )
}

export default SafetyCaseHazardCard
